// utils/billingYear.ts

export const getCurrentBillingYear = (): number => {
  const now = new Date();
  const month = now.getMonth() + 1; // JavaScript months are 0-indexed
  return month >= 11 ? now.getFullYear() + 1 : now.getFullYear();
};

// Billing Period: November 1 - October 31 (used for invoicing)
export const getBillingPeriodStart = (billingYear: number): Date => {
  return new Date(Date.UTC(billingYear - 1, 10, 1, 0, 0, 0)); // November 1st UTC (month is 0-indexed)
};

export const getBillingPeriodEnd = (billingYear: number): Date => {
  return new Date(Date.UTC(billingYear, 9, 31, 23, 59, 59)); // October 31st UTC
};

// Work Hours Period: December 1 - November 30 (used for volunteer hour tracking)
export const getWorkHoursPeriodStart = (billingYear: number): Date => {
  return new Date(Date.UTC(billingYear - 1, 11, 1, 0, 0, 0)); // December 1st UTC (month is 0-indexed)
};

export const getWorkHoursPeriodEnd = (billingYear: number): Date => {
  return new Date(Date.UTC(billingYear, 10, 30, 23, 59, 59)); // November 30th UTC
};
